var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":_vm.fieldId,"type":"text","disabled":_vm.disabled},on:{"input":_vm.change}}),_vm._v(" "),(_vm.label)?_c('label',{attrs:{"for":_vm.fieldId}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }